<header>
  <div class="filters">
    <ng-content select="[filters]"></ng-content>
  </div>
  <button class="base-table-header-button toggler" [attr.isActive]="isToggleActive ? 'active' : ''" (click)="onClickToggle()">
    <app-svg-icon [icon]="IconsConstants.COLOR_TOGGLE_ICON"></app-svg-icon>
  </button>
</header>
